import React, { useEffect, useRef, useState } from 'react';
// import '../Dao.css';
import { ethers } from "ethers";
import {
  useAddress,
  ConnectWallet,
  Web3Button,
  useContract,
  useContractWrite,
} from "@thirdweb-dev/react";

const ClaimComponent = () => {
  const address = useAddress();
  const [illuminatiIds, setIlluminatiIds] = useState([]);
  const [arrLength, setArrLength] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    if (address) {
      // checkTokens(address);
    }
  }, [address]);

  const previousAddressRef = useRef();
  useEffect(() => {
    previousAddressRef.current = address;
  }, [address]);
  const previousAddress = previousAddressRef.current;

  useEffect(() => {
    if (previousAddress && !address) {
      document.getElementById("eligible-tokens").style.display="none";
    }
  }, [address, previousAddress]);

  const contract = {
    address: "0xe25f0fe686477f9df3c2876c4902d3b85f75f33a",
    abi: [
      "function claim(uint256[] calldata illuminatiIDs) external",
      "function checkIlluminatiTokens(address owner) public view returns (uint256[] memory)",
      "function checkClaimed(uint256 tokenId) public view returns (bool)",
      "function claimLive() external view returns (bool)",
    ]
  };

  async function checkTokens(address) {
    const RPC = "https://eth-mainnet.g.alchemy.com/v2/x2clG0iamQo50Ymz3JD1IuTkvf0MGRO1";
    const provider = new ethers.providers.JsonRpcProvider(RPC);

    const CONTRACT_ADDRESS = new ethers.Contract(contract.address, contract.abi, provider);

    const bigNumberArray = await CONTRACT_ADDRESS.checkIlluminatiTokens(address);
    const numberArray = bigNumberArray.map(bigNumber => bigNumber.toNumber());

    setIlluminatiIds(numberArray);
    setArrLength(numberArray.length);

    document.getElementById("eligible-tokens").style.display=null

  }

  function go() {
    document.getElementById("success").style.display = null;
    document.getElementById("refresh").style.display = null;
    document.getElementById("bio").style.display = "none";
    document.getElementById("eligible").style.display = "none";
    setIsButtonDisabled(true);
  }

  function refresh() {
    window.location.reload();
  }

  function home() {
    window.location.href = "https://illuminatinft.com/claim";
  }

  return (
    <div className="claim-component">
      <div id="DAO-Claim-Actions">
        <div id="Claim">
          <div id="Token">
            <img id="Token-Mascot" src="i/dao.gif" alt="token mascot" />
          </div>
          <div id="prepare">
            <div id="Token-Copy" className="copy">
              <div>
              <button
                  id="home"
                  className="btn"
                  onClick={home}
                >
                  Go Home
                </button>
                <br></br><br></br>
                <h1>Claim your DAO Tokens</h1>
                <p id="bio"> 
                  This token grants you the privilege of joining the Illuminati DAO,
                  unlocking voting access to the DAO's Treasury. This is a power
                  coveted by many, but only a select few shall hold.
                </p>
                <p id="eligible-tokens" style={{display:"none"}}>
                    <span style={{ color: illuminatiIds.length === 0 ? "#fd4b4b" : "inherit" }}>
                      {illuminatiIds.length === 0 ? "You are not eligible" : "Eligible Tokens: " + illuminatiIds.join(", ")}
                    </span>
                  </p>
                <p id="success" style={{ display: "none" }}>
                  Your token claim has been submitted to the network. You can view
                  your token on{" "}
                  <a
                    href="https://opensea.io/assets/ethereum/0xe25f0fe686477f9df3c2876c4902d3b85f75f33a/1"
                    target="_blank"
                    className="fancy-link"
                  >
                    OpenSea
                  </a>{" "}
                  &amp; utilize your token in the dao on{" "}
                  <a
                    href="https://truth.upstreamapp.com/"
                    target="_blank"
                    className="fancy-link-2"
                  >
                    Upstream
                  </a>
                  .
                </p>
                <br></br>
                <p>Claim resuming shortly</p>
                {/* <Web3Button
                  contractAddress="0x1956C04491FFEf5cFF4E5c4b3b494125626e4757"
                  action={(contract) => {
                    contract.call("claimTokensFor", [illuminatiIds]);
                  }}
                  onSubmit={() => go()}
                  onSuccess={() => go()}
                  style={{ display: isButtonDisabled ? "none" : "null" }}
                >
                  {arrLength === 1 ? "Claim 1 Token" : `Claim ${arrLength} Tokens`}
                </Web3Button> */}
                <button
                  id="refresh"
                  className="btn"
                  style={{ display: "none" }}
                  onClick={refresh}
                >
                  Start Over
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClaimComponent;
